import state from './moduleCampaignState'
import actions from './moduleCampaignActions'
import getters from './moduleCampaignGetters'
import mutations from './moduleCampaignMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

